module.exports = __webpack_public_path__ + "img/eye-in-client-king-charters.97b0b45e.webp";